import { Link } from "react-router-dom";
import { Twitter, Github, Linkedin } from "lucide-react";
import { Wordmark } from "@/components/Wordmark";

export function Footer() {
  return (
    <footer className="relative mt-32 border-t border-slate-900/8 bg-white/70 dark:border-white/5 dark:bg-transparent">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-12 px-6 py-16 sm:px-8 md:grid-cols-4 lg:px-12">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="inline-flex items-center" data-testid="footer-logo" aria-label="Symplee — home">
            <Wordmark variant="dark" size="sm" />
          </Link>
          <p className="mt-4 max-w-xs text-sm text-slate-600 dark:text-white/55">
            AI made simple for your business.
          </p>
          <div
            className="mt-4 rounded-lg border border-slate-900/8 bg-slate-50/70 px-3 py-2 text-xs leading-relaxed text-slate-600 dark:border-white/8 dark:bg-white/5 dark:text-white/55"
            data-testid="footer-promise"
          >
            <span className="font-medium text-slate-800 dark:text-white/85">Our promise.</span>{" "}
            One simple price. No contracts. Fully reversible.
          </div>
          <div className="mt-5 flex items-center gap-2 text-slate-500 dark:text-white/40">
            <a href="#" aria-label="Twitter" className="rounded-md p-2 transition hover:bg-slate-100 hover:text-slate-900 dark:hover:bg-white/5 dark:hover:text-white"><Twitter className="h-4 w-4" /></a>
            <a href="#" aria-label="GitHub" className="rounded-md p-2 transition hover:bg-slate-100 hover:text-slate-900 dark:hover:bg-white/5 dark:hover:text-white"><Github className="h-4 w-4" /></a>
            <a href="#" aria-label="LinkedIn" className="rounded-md p-2 transition hover:bg-slate-100 hover:text-slate-900 dark:hover:bg-white/5 dark:hover:text-white"><Linkedin className="h-4 w-4" /></a>
          </div>
        </div>

        <FooterColumn title="Product" items={[
          { label: "Pricing", to: "/pricing" },
          { label: "Why Symplee", to: "/#why" },
          { label: "How it works", to: "/#how-it-works" },
          { label: "Sign in", to: "/login" },
        ]} />
        <FooterColumn title="Company" items={[
          { label: "About", to: "/about" },
          { label: "Our Promise", to: "/promise" },
          { label: "Careers", to: "#" },
          { label: "Blog", to: "#" },
          { label: "Contact", to: "#" },
        ]} />
        <FooterColumn title="Legal" items={[
          { label: "Privacy", to: "#" },
          { label: "Terms", to: "#" },
          { label: "Security", to: "#" },
          { label: "DPA", to: "#" },
        ]} />
      </div>

      <div className="border-t border-slate-900/8 dark:border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-6 text-xs text-slate-500 dark:text-white/45 sm:flex-row sm:px-8 lg:px-12">
          <p>© {new Date().getFullYear()} Symplee. All rights reserved.</p>
          <p className="text-slate-500 dark:text-white/40">No contracts · No upsells · Cancel anytime</p>
        </div>
        <div className="mx-auto max-w-7xl px-6 pb-6 text-center sm:px-8 sm:text-left lg:px-12">
          <p className="text-[11px] italic text-slate-400 dark:text-white/35" data-testid="footer-portfolio-line">
            An Automation Prime portfolio company
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, items }) {
  return (
    <div>
      <div className="text-eyebrow text-slate-500 dark:text-white/40">{title}</div>
      <ul className="mt-4 space-y-2">
        {items.map((i, idx) => (
          <li key={idx}>
            <Link to={i.to} className="text-sm text-slate-600 transition hover:text-slate-900 dark:text-white/65 dark:hover:text-white">
              {i.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
